import {MuWidget} from "mu-widget/lib/MuWidget";

export class BaseWidget extends MuWidget {

}